<template>
  <div v-if="subscribed" class="grid-wrapper">
    <billing-subscription-component @onSubscriptionLoad="onSubscriptionLoad" />

    <billing-payment-methods-component />

    <div>
      <div class="centered-column">
        <div class="white-card" v-if="loaded && !cancelled">
          <div class="white-card-header">
            <div class="title-wrap">
              <label class="title-label">
                {{ label.get("cancel_subscription") }}</label
              >
            </div>
          </div>
          <div class="cancel-subscription">
            <p>
              {{ label.get("subscription_cancelling_description") }}
            </p>
            <button class="atto-btn cancel md-btn" @click="cancelSubscription">
              {{ label.get("cancel_subscription") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <billing-receipts-component v-if="!isMobile" />

    <cancel-subscription-component
      v-if="showCancelSubscription"
      :next-payment="nextPayment"
    />
  </div>
</template>

<script>
import BillingSubscriptionComponent from "./components/BillingSubscriptionComponent";
import BillingPaymentMethodsComponent from "./components/BillingPaymentMethodsComponent";
import BillingReceiptsComponent from "./components/BillingReceiptsComponent";
import CancelSubscriptionComponent from "./components/CancelSubscriptionComponent";
import UtilsService from "../../../shared/services/UtilsService";
import BillingService from "./services/BillingService";

export default {
  name: "BillingComponent",
  components: {
    BillingSubscriptionComponent,
    BillingPaymentMethodsComponent,
    BillingReceiptsComponent,
    CancelSubscriptionComponent,
  },
  data() {
    return {
      cancelled: false,
      loaded: false,
      nextPayment: null,
      showCancelSubscription: false,
    };
  },
  computed: {
    subscribed() {
      if (!this.$store.state.permission.canAccessBilling) {
        return false;
      }
      return this.$store.state.subscribed;
    },
    isMobile() {
      return UtilsService.isMobile.any();
    },
  },
  beforeMount() {
    if (!this.$store.state.permission.canAccessBilling) {
      this.$router.push({ path: "/activity" });
    }
    if (!this.$store.state.subscribed) {
      this.$router.push({ path: "/subscription/plans" });
    }
  },
  mounted() {
    this.$root.$on("hideCancelSubscription", this.hideCancelSubscription);
  },
  methods: {
    onSubscriptionLoad(data) {
      this.cancelled = data.cancelled;
      this.nextPayment = data.nextPayment;
      this.loaded = true;
    },
    cancelSubscription() {
      this.showCancelSubscription = true;
      // window.profitwell('init_cancellation_flow').then(result => {
      //   debugger;
      //   // This means the customer either aborted the flow (i.e.
      //   // they clicked on "never mind, I don't want to cancel"), or
      //   // accepted a salvage attempt or salvage offer.
      //   // Thus, do nothing since they won't cancel.
      //   if (result.status === 'retained' || result.status === 'aborted') {
      //     return
      //   }
      //
      //   // At this point, the customer ended deciding to cancel (i.e.
      //   // they rejected the salvage attempts and the salvage offer).
      //   // It could also be the case the widget couldn't be shown properly for
      //   // some reason (for which case, `result.status` will be 'error'), but that
      //   // shouldn't stop them from cancelling.
      //
      //   // The normal cancel flow goes here
      //   BillingService.cancelSubscription({})
      //       .then(() => {
      //         this.disabled = false;
      //         location.reload();
      //         this.$store.commit("hideLoading");
      //       })
      //       .catch(() => {
      //         this.disabled = false;
      //         this.$store.commit("hideLoading");
      //       });
      // })
    },

    hideCancelSubscription(cancel) {
      this.showCancelSubscription = false;
      if (cancel) {
        this.cancelled = true;
      }
    },
  },
};
</script>

<style lang="scss">
/* @media queries */
@mixin tablet {
  @media (max-width: 767px) and (min-width: 481px) {
    @content;
  }
}
@mixin mobile {
  @media (max-width: 480px) {
    @content;
  }
}
/* End of: @media queries */

.container-wrap .content {
  .content-section {
    > h3 {
      font-family: "Roboto", sans-serif;
      font-size: 1.125rem;
      line-height: 2rem;
      font-weight: 500;
      color: #262626;
      margin: 28px 0;
    }
  }
}
.cancel-subscription {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 40px;
  p {
    color: $atto-red;
    font: $roboto-regular 0.9375rem/1.25rem $roboto-font;
    margin: 0;
  }
  button {
    &.cancel {
      width: 240px;
      margin-left: 20px;
      background-color: transparent;
      border: 1px solid $atto-light-grey;
      color: $atto-font-color;
      text-transform: uppercase;
      font-weight: $roboto-bold;
      @include tablet {
        min-width: 240px;
      }
      @include mobile {
        width: 100%;
        margin-left: 0;
      }
    }
  }
  @include mobile {
    flex-direction: column;
    align-items: stretch;
    p {
      width: 100%;
      margin-bottom: 12px;
    }
  }
}
@media (max-width: 768px) {
  .settings-page {
    .container-wrap {
      padding-left: 0 !important;

      .content {
        max-width: 100%;

        .heading {
          text-align: center;
        }
      }
    }
  }
}
</style>
